import { RecoilState, atom } from "recoil";

export const STORAGE_EXEMPT_USER_GROUPS = ["CREATOR_PLAT", "INTERNAL"];

export interface IStorageStatusState {
  savedCount: number;
  limit: number | null;
  isUnlimited: boolean;
}

export const StorageStatusAtom: RecoilState<IStorageStatusState | null> = atom({
  key: "StorageStatus_V0.2",
  default: null as IStorageStatusState | null,
});

export const SavedClipStatusAtom: RecoilState<Record<string, boolean>> = atom({
  key: "SavedClipStatus_V0.1",
  default: {} as Record<string, boolean>,
});
